module.exports = __webpack_public_path__ + "img/data_downlod_txt1.d2682f62.png";